var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLawndoctorsIllustrationsFreeinstantpriceLotsizeCity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "90 273 439 227",
    enableBackground: "new 90 273 439 227",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_168_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1706_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1707_",
    fill: "#C0EA96",
    d: "M507.4,415.5c0,0,2.6,42.2-48,49c-40.5,5.4-40.9,21.3-87.2,17.1 c-48.5-4.4-68.3,6-96.8,5.3c-37.3-1.1-47-14.2-90.7-15.5c-43.7-1.4-74.5-39.6-69.4-56.4L507.4,415.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_321_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_514_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1704_",
    fill: "#6A7269",
    d: "M488.8,414.4h-43.6c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h43.6 c0.2,0,0.4,0.2,0.4,0.4S489.1,414.4,488.8,414.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_319_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_513_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1701_",
    fill: "#6A7269",
    d: "M437.6,414.4H145.3c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h292.2 c0.2,0,0.4,0.2,0.4,0.4S437.8,414.4,437.6,414.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_206_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_504_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_505_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1697_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1698_",
    fill: "#FFFFFF",
    d: "M253.7,485.6l32.8-47.2c-6.5-0.1-48.5-1.7-55.3-1.6l-45.9,39.9L253.7,485.6z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_458_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_459_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1693_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1694_",
    fill: "#6A7269",
    d: "M184.9,476.8c-0.1,0-0.2-0.1-0.2-0.2c-0.2-0.2-0.2-0.5-0.2-0.8l45.7-38.4 c0.2-0.2,0.4-0.2,0.5-0.1c0.2,0.2,0.2,0.5,0.2,0.8l-45.7,38.4C185.1,476.8,185.1,476.8,184.9,476.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_456_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_457_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1689_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1690_",
    fill: "none",
    stroke: "#6A7269",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M232.7,437.8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_135_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_303_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1685_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1686_",
    fill: "#E1E7EA",
    d: "M259.3,477.1l27.2-38.7c-6.5-0.1-44.7-1.7-51.5-1.6l-39,33.8 c-2.5,2.2-1.1,6.4,2.2,6.7l52.1,4C253.8,481.6,257.2,480,259.3,477.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_452_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_455_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1681_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1682_",
    fill: "#6A7269",
    d: "M253.8,485.6L253.8,485.6c-0.3-0.1-0.5-0.3-0.5-0.6l32.9-46.5 c0.2-0.3,0.5-0.5,0.7-0.5s0.4,0.3,0.4,0.6L254.4,485C254.2,485.4,253.9,485.6,253.8,485.6z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_221_",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_223_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1677_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1678_",
    fill: "#6A7269",
    d: "M279.2,445.7L228,445c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4l51.3,0.8 c0.2,0,0.4,0.2,0.4,0.4S279.5,445.7,279.2,445.7z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_231_",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_232_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1673_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1674_",
    fill: "#6A7269",
    d: "M270.8,457.2l-54.3-1.5c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4l54.3,1.5 c0.2,0,0.4,0.2,0.4,0.4S271,457.2,270.8,457.2z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_233_",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_236_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1669_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1670_",
    fill: "#6A7269",
    d: "M262.4,469.4l-57.4-2.3c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4l57.4,2.3 c0.2,0,0.4,0.2,0.4,0.4S262.6,469.4,262.4,469.4z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_254_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_350_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_351_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1664_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1665_",
    fill: "#FFFFFF",
    d: "M323.8,487.4l1.4-25.3l1.8-29.9c-6.5-0.1-11.7-0.1-18.5,0l-16.5,31.4l-12.2,24.3 L323.8,487.4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_348_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_349_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1660_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1661_",
    fill: "#E1E7EA",
    d: "M309.5,433.7L289,478.8c-1.2,2.6,0.7,5.7,3.6,5.7l23.7,0.5c4.2,0.1,7.6-3.1,7.9-7.3 l2.1-43.8C321.1,433.7,315,433.7,309.5,433.7z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_346_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_347_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1656_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1657_",
    fill: "#6A7269",
    d: "M284.4,479.8c-0.1,0-0.2-0.1-0.2-0.2c-0.2-0.2-0.2-0.5-0.2-0.8l23.5-46.1 c0.2-0.2,0.4-0.2,0.5-0.1c0.2,0.2,0.2,0.5,0.2,0.8l-23.5,46.1C284.6,479.8,284.5,479.8,284.4,479.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_344_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_345_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1652_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1653_",
    fill: "none",
    stroke: "#6A7269",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M310,433.2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_342_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_343_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1648_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1649_",
    fill: "#6A7269",
    d: "M324.1,484.8L324.1,484.8c-0.3-0.1-0.5-0.3-0.5-0.6l2.6-51.2c0-0.3,0.2-0.5,0.5-0.4 c0.2,0.1,0.4,0.3,0.4,0.6l-2.6,51.2C324.4,484.7,324.3,484.8,324.1,484.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_340_",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_341_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1644_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1645_",
    fill: "#6A7269",
    d: "M297.6,479.7c-0.1,0-0.2,0-0.2-0.1c-0.2-0.2-0.3-0.5-0.2-0.7l15.8-45.7 c0.1-0.2,0.3-0.3,0.5-0.2c0.2,0.2,0.3,0.5,0.2,0.7l-15.8,45.7C297.8,479.6,297.7,479.7,297.6,479.7z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_338_",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_339_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1640_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1641_",
    fill: "#6A7269",
    d: "M309,480.8c-0.1,0-0.1,0-0.2-0.1c-0.2-0.1-0.3-0.4-0.3-0.7l10.3-46.9 c0.1-0.2,0.3-0.4,0.5-0.2c0.2,0.1,0.3,0.4,0.3,0.7l-10.3,46.9C309.3,480.6,309.1,480.8,309,480.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_336_",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_337_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1636_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1637_",
    fill: "#6A7269",
    d: "M326.5,435.8h-19.2c-0.2,0-0.4-0.1-0.5-0.4c0-0.3,0.2-0.4,0.4-0.4h19.2 c0.2,0,0.4,0.1,0.5,0.4S326.7,435.8,326.5,435.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_334_",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_335_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1632_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1633_",
    fill: "#6A7269",
    d: "M325.8,444.2h-22c-0.2,0-0.4-0.1-0.5-0.4c0-0.3,0.2-0.4,0.4-0.4h22 c0.2,0,0.4,0.1,0.5,0.4S326,444.2,325.8,444.2z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_332_",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_333_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1628_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1629_",
    fill: "#6A7269",
    d: "M325,451.1h-24.3c-0.2,0-0.4-0.1-0.5-0.4c0-0.3,0.2-0.4,0.4-0.4h24.3 c0.2,0,0.4,0.1,0.5,0.4C325.4,451,325.2,451.1,325,451.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_330_",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_331_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1624_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1625_",
    fill: "#6A7269",
    d: "M324.3,459.5H296c-0.2,0-0.4-0.1-0.5-0.4c0-0.3,0.2-0.4,0.4-0.4h28.3 c0.2,0,0.4,0.1,0.5,0.4C324.7,459.4,324.5,459.5,324.3,459.5z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_77_",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_78_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1620_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1621_",
    fill: "#6A7269",
    d: "M324.2,469.4h-32.9c-0.2,0-0.4-0.1-0.5-0.4c0-0.3,0.2-0.4,0.4-0.4h32.9 c0.2,0,0.4,0.1,0.5,0.4C324.6,469.4,324.4,469.4,324.2,469.4z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_253_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_586_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_689_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_690_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1615_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1616_",
    fill: "#E6E7E8",
    points: "229.7,393.7 226.3,393.7 261.4,358.7 296.3,393.7 288.6,393.7  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_687_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_688_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1611_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1612_",
    fill: "#DCE6EA",
    points: "290.7,392.4 260.3,362.1 229.5,392.4 229.5,438.8 290.7,438.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_577_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_578_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1608_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1609_",
    x: 232.5,
    y: 395.5,
    fill: "#FFFFFF",
    width: 54.9,
    height: 42.7
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_575_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_576_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1604_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1605_",
    x: 234.5,
    y: 397.6,
    fill: "#C6EAF4",
    width: 52.9,
    height: 40.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_58_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_59_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1600_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1601_",
    fill: "#6A7269",
    d: "M287.4,437.5c-0.2,0-0.4-0.2-0.4-0.4v-41.2h-26.1c-0.2,0-0.4-0.2-0.4-0.4 s0.2-0.4,0.4-0.4h26.5c0.2,0,0.4,0.2,0.4,0.4v41.6C287.8,437.3,287.6,437.5,287.4,437.5z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_56_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_57_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1596_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1597_",
    fill: "#6A7269",
    d: "M256.7,395.9H251c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h5.7 c0.2,0,0.4,0.2,0.4,0.4S256.9,395.9,256.7,395.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_54_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_55_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1592_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1593_",
    fill: "#6A7269",
    d: "M247.4,395.9h-1.5c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h1.5 c0.2,0,0.4,0.2,0.4,0.4S247.6,395.9,247.4,395.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_52_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_53_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1588_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1589_",
    fill: "#6A7269",
    d: "M232.5,436.6c-0.2,0-0.4-0.2-0.4-0.4v-40.8c0-0.2,0.2-0.4,0.4-0.4h10 c0.2,0,0.4,0.2,0.4,0.4s-0.2,0.4-0.4,0.4h-9.6v40.4C232.9,436.5,232.7,436.6,232.5,436.6z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_50_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_51_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1584_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1585_",
    fill: "#6A7269",
    d: "M285.3,404.4h-49.7c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h49.7 c0.2,0,0.4,0.2,0.4,0.4S285.6,404.4,285.3,404.4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_48_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_49_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1580_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1581_",
    fill: "#6A7269",
    d: "M285.3,412.8h-49.7c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4h49.7 c0.2,0,0.4,0.2,0.4,0.4C285.7,412.7,285.6,412.8,285.3,412.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_46_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_47_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1576_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1577_",
    fill: "#6A7269",
    d: "M285.3,421.2h-49.7c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h49.7 c0.2,0,0.4,0.2,0.4,0.4S285.6,421.2,285.3,421.2z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_44_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_45_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1572_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1573_",
    fill: "#6A7269",
    d: "M285.3,429.7h-49.7c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h49.7 c0.2,0,0.4,0.2,0.4,0.4S285.6,429.7,285.3,429.7z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_685_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_686_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1566_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1567_",
    fill: "#DCE6EA",
    points: "290.7,432.4 372.6,432.3 372.6,392.5 290.3,392.8  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_683_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_684_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1562_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1563_",
    fill: "#C2CFD3",
    points: "290.7,432.3 295.3,432.5 295.3,396 372.6,395.2 372.6,392.2 290.2,392.9  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_664_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_665_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1558_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1559_",
    fill: "#C2CFD3",
    points: "229.5,392.4 229.5,396.5 260.5,366.7 290.7,397 290.7,392.4 260.3,362.1  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_662_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_663_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1554_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1555_",
    fill: "#D3DADD",
    points: "271.1,364.6 368.9,364.6 377.8,392.9 299.3,392.9  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_660_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_661_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1550_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1551_",
    fill: "#6A7269",
    d: "M290.3,438.8h-61.2c-0.2,0-0.4-0.2-0.4-0.4v-46.1c0-0.1,0.1-0.2,0.1-0.3l30.7-30.4 c0.2-0.2,0.4-0.2,0.5,0c0.2,0.2,0.2,0.4,0,0.5l-30.5,30.3v45.5h60.4v-5.8c0-0.1,0.1-0.2,0.1-0.3c0.1-0.1,0.2-0.2,0.3-0.1 l82.2,0.1v-39.4c0-0.2,0.2-0.4,0.4-0.4h4.4l-9.4-30.6l-103.2,0.8c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4l103.4-0.8 c0.2,0,0.3,0.1,0.4,0.2l9.7,31.4c0,0.2,0,0.2-0.1,0.3s-0.2,0.2-0.3,0.2h-4.5v39.4c0,0.1,0.7,0.2,0.7,0.3 c-0.1,0.1-0.2,0.2-0.3,0.2c0,0,0,0-0.8,0l-83-0.1l0.8,5.8C290.7,438.7,290.5,438.8,290.3,438.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_658_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_659_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1546_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1547_",
    fill: "#6A7269",
    d: "M374.9,392.9h-84.5c-0.1,0-0.2-0.1-0.3-0.1l-30.6-30.7c-0.2-0.2-0.2-0.4,0-0.5 s0.4-0.2,0.5,0l30.4,30.6h84.5c0.2,0,0.4,0.2,0.4,0.4S375.1,392.9,374.9,392.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_656_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_657_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1542_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1543_",
    fill: "#6A7269",
    d: "M365.7,366.9l-94.1,0.8c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4l94.1-0.8 c0.2,0,0.4,0.2,0.4,0.4S365.9,366.9,365.7,366.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_654_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_655_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1538_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1539_",
    fill: "#6A7269",
    d: "M368.7,376.1l-89.5,0.8c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4l89.5-0.8 c0.2,0,0.4,0.2,0.4,0.4S369,376.1,368.7,376.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_652_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_653_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1534_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1535_",
    fill: "#6A7269",
    d: "M371.8,386.8h-82.6c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h82.6 c0.2,0,0.4,0.2,0.4,0.4S372,386.8,371.8,386.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_650_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_651_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1530_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1531_",
    fill: "#6A7269",
    d: "M228.7,392.9h-3.3c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.2,0-0.3,0.1-0.4l10.3-10.3 c0.2-0.2,0.4-0.2,0.5,0c0.2,0.2,0.2,0.4,0,0.5l-9.6,9.6h2.4c0.2,0,0.4,0.2,0.4,0.4S229,392.9,228.7,392.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_648_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_649_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1526_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1527_",
    fill: "#6A7269",
    d: "M237.5,381.2c-0.1,0-0.2,0-0.3-0.1c-0.2-0.2-0.2-0.4,0-0.5l14.1-14.1 c0.2-0.2,0.4-0.2,0.5,0c0.2,0.2,0.2,0.4,0,0.5l-14.1,14.1C237.7,381.1,237.6,381.2,237.5,381.2z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_646_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_647_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1522_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1523_",
    fill: "#6A7269",
    d: "M253.7,364.9c-0.1,0-0.2,0-0.3-0.1c-0.2-0.2-0.2-0.4,0-0.5l3.6-3.6 c0.2-0.2,0.4-0.2,0.5,0c0.2,0.2,0.2,0.4,0,0.5l-3.6,3.6C253.9,364.9,253.8,364.9,253.7,364.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_644_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_645_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1518_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1519_",
    fill: "#6A7269",
    d: "M295.5,393c-0.1,0-0.2,0-0.3-0.1l-34.7-34.7l-0.8,0.8c-0.2,0.2-0.4,0.2-0.5,0 c-0.2-0.2-0.2-0.4,0-0.5l1.1-1.1c0.2-0.2,0.4-0.2,0.5,0l35,35c0.2,0.2,0.2,0.4,0,0.5C295.7,393,295.6,393,295.5,393z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_609_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_642_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_643_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1514_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1515_",
    fill: "#FFFFFF",
    points: "329.7,401.7 329.7,428.9 332,428.9 332,431.2 299.9,431.2 299.9,428.9  302.9,428.9 302.9,401.7 302.9,399.1 301.4,399.1 301.4,396 331.7,396 331.8,399.1 329.7,399.1  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_640_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_641_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1510_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1511_",
    x: 307.5,
    y: 401.4,
    fill: "#D3DADD",
    width: 19.9,
    height: 29.8
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_638_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_639_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1506_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1507_",
    x: 313.8,
    y: 406.7,
    fill: "#E2E7E8",
    width: 6.2,
    height: 8.6
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_636_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_637_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1502_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1503_",
    x: 313.8,
    y: 420.3,
    fill: "#BAC4C6",
    width: 6.2,
    height: 8.3
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_634_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_635_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1498_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1499_",
    fill: "#FFFFFF",
    cx: 309.7,
    cy: 417.6,
    r: 1.3
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_630_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_631_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1492_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1493_",
    fill: "#6A7269",
    d: "M327,431.2h-20.7c-0.2,0-0.4-0.2-0.4-0.4v-31.4c0-0.2,0.2-0.4,0.4-0.4H327 c0.2,0,0.4,0.2,0.4,0.4v31.4C327.4,431,327.3,431.2,327,431.2z M306.8,430.4h19.9v-30.6h-19.9V430.4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_626_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_627_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1486_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1487_",
    fill: "#6A7269",
    d: "M309.7,419.3c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7 C311.4,418.6,310.7,419.3,309.7,419.3z M309.7,416.8c-0.5,0-0.9,0.4-0.9,0.9s0.4,0.9,0.9,0.9c0.5,0,0.9-0.4,0.9-0.9 S310.2,416.8,309.7,416.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_622_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_623_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1480_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1481_",
    fill: "#6A7269",
    d: "M320.1,415.7h-6.2c-0.2,0-0.4-0.2-0.4-0.4v-8.6c0-0.2,0.2-0.4,0.4-0.4h6.2 c0.2,0,0.4,0.2,0.4,0.4v8.6C320.5,415.6,320.2,415.7,320.1,415.7z M314.2,415h5.4v-7.9h-5.4V415z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_618_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_619_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1474_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1475_",
    fill: "#6A7269",
    d: "M320.1,429h-6.2c-0.2,0-0.4-0.2-0.4-0.4v-8.3c0-0.2,0.2-0.4,0.4-0.4h6.2 c0.2,0,0.4,0.2,0.4,0.4v8.3C320.5,428.8,320.2,429,320.1,429z M314.2,428.3h5.4v-7.6h-5.4V428.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_614_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_615_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1468_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1469_",
    fill: "#6A7269",
    d: "M331.6,399.8h-30c-0.2,0-0.4-0.2-0.4-0.4v-3.7c0-0.2,0.2-0.4,0.4-0.4h30 c0.2,0,0.4,0.2,0.4,0.4v3.7C332,399.7,331.9,399.8,331.6,399.8z M302,399.1h29.2v-3H302V399.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_612_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_613_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1464_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1465_",
    fill: "#6A7269",
    d: "M301,430.8c-0.2,0-0.4-0.2-0.4-0.4v-1.9c0-0.2,0.2-0.4,0.4-0.4h1.9v-26.8 c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4v27.2c0,0.2-0.2,0.4-0.4,0.4h-1.9v1.5C301.4,430.7,301.3,430.8,301,430.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_610_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_611_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1460_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1461_",
    fill: "#6A7269",
    d: "M332.4,430.8c-0.2,0-0.4-0.2-0.4-0.4v-1.5h-1.9c-0.2,0-0.4-0.2-0.4-0.4v-27.2 c0-0.2,0.2-0.4,0.4-0.4s0.4,0.2,0.4,0.4v26.8h1.9c0.2,0,0.4,0.2,0.4,0.4v1.9C332.8,430.7,332.6,430.8,332.4,430.8z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_605_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_606_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1453_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1454_",
    fill: "#6A7269",
    d: "M290.3,438.8h-61.2c-0.2,0-0.4-0.2-0.4-0.4v-46.1c0-0.1,0.1-0.2,0.1-0.3l30.8-30.3 c0.2-0.2,0.4-0.2,0.5,0l30.4,30.3c0.1,0.1,0.1,0.2,0.1,0.3v46.1C290.7,438.7,290.5,438.8,290.3,438.8z M229.5,438.1h60.4 v-45.5l-30-29.9l-30.4,29.9V438.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_603_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_604_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1449_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1450_",
    fill: "none",
    stroke: "#6A7269",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M290.2,392.8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_255_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_403_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_407_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_503_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1445_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1446_",
    x: 341.2,
    y: 401.4,
    fill: "#FFFFFF",
    width: 22.9,
    height: 21.4
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_400_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_401_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_402_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1440_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1441_",
    x: 341.2,
    y: 401.4,
    fill: "#C6EAF4",
    width: 21.4,
    height: 19.9
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_273_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_274_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_275_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1433_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1434_",
    fill: "#6A7269",
    d: "M364.9,423.2c0,0.2-0.2,0.4-0.4,0.4h-23.7c-0.2,0-0.4-0.2-0.4-0.4V401 c0-0.2,0.2-0.4,0.4-0.4h23.7c0.2,0,0.4,0.2,0.4,0.4V423.2z M341.2,422.8h22.9v-21.4h-22.9V422.8z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_270_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_271_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_272_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1428_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1429_",
    fill: "#6A7269",
    d: "M348.5,423.5c-0.2,0-0.4-0.2-0.4-0.4v-19.2c0-0.2,0.2-0.4,0.4-0.4 s0.4,0.2,0.4,0.4v19.2C348.8,423.2,348.7,423.5,348.5,423.5z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_267_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_268_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_269_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1423_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1424_",
    fill: "#6A7269",
    d: "M356.1,423.5c-0.2,0-0.4-0.2-0.4-0.4v-19.2c0-0.2,0.2-0.4,0.4-0.4 s0.4,0.2,0.4,0.4v19.2C356.5,423.2,356.3,423.5,356.1,423.5z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_264_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_265_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_266_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1418_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1419_",
    fill: "#6A7269",
    d: "M360.4,409.8h-16.8c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4h16.8 c0.2,0,0.4,0.2,0.4,0.4C360.8,409.6,360.6,409.8,360.4,409.8z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_259_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_260_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_263_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1413_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1414_",
    fill: "#6A7269",
    d: "M360.4,418.2h-16.8c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h16.8 c0.2,0,0.4,0.2,0.4,0.4S360.6,418.2,360.4,418.2z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_256_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_257_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_258_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1408_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1409_",
    fill: "#6A7269",
    d: "M366.8,423.5H338c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h28.8 c0.2,0,0.4,0.2,0.4,0.4S367,423.5,366.8,423.5z"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_79_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_432_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_433_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1401_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1402_",
    fill: "#BFA088",
    points: "306,291.2 306,292 308.3,292 308.3,293.5 318.2,293.5 318.2,292 320.5,292  320.5,291.2  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_41_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_434_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_438_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1397_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1398_",
    fill: "#C6EAF4",
    points: "308.3,302.7 318.2,302.7 318.2,292 320.5,292 320.5,288.1 306,288.1  306,292 308.3,292  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_365_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_366_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1391_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1392_",
    fill: "#6A7269",
    d: "M317.5,302.8h-9.9c-0.2,0-0.4-0.2-0.4-0.4v-11.2c0-0.2,0.2-0.4,0.4-0.4h9.9 c0.2,0,0.4,0.2,0.4,0.4v11.2C317.9,302.7,317.7,302.8,317.5,302.8z M307.9,302.1h9.2v-10.4h-9.2V302.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_88_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_448_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_449_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_450_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1387_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1388_",
    fill: "#DCE6EA",
    points: "334.1,382.9 373.3,382.8 373.3,338.9 333.6,338.5  "
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_419_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_420_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_447_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1382_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1383_",
    fill: "#C2CFD3",
    points: "334.3,382.2 339.7,382.2 339.7,341.7 373.3,341.7 373.3,337.9  333.6,337.9  "
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_404_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_405_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_406_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1377_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1378_",
    fill: "#C6EAF4",
    points: "311.7,306.5 369.3,306.5 379.5,338.6 342.1,338.6  "
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_395_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_396_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_397_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1372_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1373_",
    fill: "#6A7269",
    d: "M334.6,338.6H377c0.2,0,0.5-0.2,0.5-0.4s-0.2-0.4-0.5-0.4h-41.9h-1.8l0.7,0.8 C334,338.6,334.5,338.6,334.6,338.6z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_276_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_372_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_393_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_394_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1367_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1368_",
    fill: "#6A7269",
    d: "M365.6,310.3h-49.9c-0.2,0-0.5-0.2-0.5-0.4s0.2-0.4,0.5-0.4h49.9 c0.2,0,0.5,0.2,0.5,0.4S365.8,310.3,365.6,310.3z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_289_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_370_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_371_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1362_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1363_",
    fill: "#6A7269",
    d: "M369.1,320.3h-44.7c-0.2,0-0.5-0.2-0.5-0.4c0-0.2,0.2-0.4,0.5-0.4h44.7 c0.2,0,0.5,0.2,0.5,0.4C369.6,320.1,369.3,320.3,369.1,320.3z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_277_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_279_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_288_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1357_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1358_",
    fill: "#6A7269",
    d: "M370.9,330.2h-36.8c-0.2,0-0.5-0.2-0.5-0.4c0-0.2,0.2-0.4,0.5-0.4h36.8 c0.2,0,0.5,0.2,0.5,0.4C371.3,330.1,371.1,330.2,370.9,330.2z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_184_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_202_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_203_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1351_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1352_",
    fill: "none",
    stroke: "#6A7269",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M333.6,338.5"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_182_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_183_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1346_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1347_",
    fill: "#DCE6EA",
    points: "301.5,304.7 268.5,337.6 268.5,361.9 290.1,383.8 333.5,383.8  333.5,338.7  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_464_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_465_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1342_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1343_",
    fill: "#C2CFD3",
    points: "333.9,363.1 333.9,364.6 373.3,364.6 373.3,363.1  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_466_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1339_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1340_",
    fill: "#C2CFD3",
    points: "334,370.8 334,372.3 373.3,372.3 373.3,370.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_467_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1336_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1337_",
    fill: "#C2CFD3",
    points: "334.1,378.4 334.1,379.9 373.3,379.9 373.3,378.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_468_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1333_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1334_",
    fill: "#C2CFD3",
    points: "333.8,355.5 333.8,357 373.3,357 373.3,355.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_469_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1330_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1331_",
    fill: "#C2CFD3",
    points: "333.6,340.2 333.7,341.7 373.3,341.7 373.3,340.2  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_470_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1327_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1328_",
    fill: "#C2CFD3",
    points: "333.8,347.8 333.8,349.3 373.3,349.3 373.3,347.8  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_408_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_409_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1323_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1324_",
    fill: "#C2CFD3",
    points: "273.5,366.9 275,368.5 333.5,368.5 333.5,366.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_410_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1320_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1321_",
    x: 268.5,
    y: 351.6,
    fill: "#C2CFD3",
    width: 65,
    height: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_411_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1317_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1318_",
    x: 268.5,
    y: 359.3,
    fill: "#C2CFD3",
    width: 65,
    height: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_412_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1314_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1315_",
    fill: "#C2CFD3",
    points: "281.1,374.6 282.5,376.1 333.5,376.1 333.5,374.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_413_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1311_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1312_",
    fill: "#C2CFD3",
    points: "288.6,382.2 290.1,383.8 333.5,383.8 333.5,382.2  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_414_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1308_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1309_",
    fill: "#C2CFD3",
    points: "277.5,328.7 275.9,330.2 325.5,330.2 324.1,328.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_415_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1305_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1306_",
    fill: "#C2CFD3",
    points: "292.8,313.4 291.2,314.9 311.1,314.9 309.7,313.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_416_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1302_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1303_",
    fill: "#C2CFD3",
    points: "300.4,305.7 298.9,307.3 303.9,307.3 302.5,305.7  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_417_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1299_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1300_",
    fill: "#C2CFD3",
    points: "269.8,336.3 268.5,337.6 268.5,337.9 332.8,337.9 331.3,336.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_418_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1296_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1297_",
    fill: "#C2CFD3",
    points: "285.1,321 283.6,322.6 318.3,322.6 316.9,321  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_462_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1293_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1294_",
    x: 268.5,
    y: 344,
    fill: "#C2CFD3",
    width: 65,
    height: 1.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_175_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_176_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1289_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1290_",
    fill: "#6A7269",
    d: "M372.9,383L372.9,383l-38.9-0.2c-0.2,0-0.5-0.2-0.5-0.5s0.4-0.3,0.4-0.3l38.6,0.2 v-44.1c0-0.2,0.2-0.4,0.4-0.4h6l-11.1-33.7h-58.8c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h59.1c0.2,0,0.3,0.1,0.4,0.2 l11.4,34.4c0.1,0.2,0,0.2-0.1,0.4c-0.1,0.1-0.2,0.2-0.3,0.2h-6.2v44.1c0,0.1-0.1,0.2-0.1,0.2C373.2,383,373,383,372.9,383z "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_171_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_172_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1283_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1284_",
    fill: "#6A7269",
    d: "M333.9,384.5h-43.5c-0.1,0-0.2-0.1-0.3-0.1l-21.5-21.9c-0.1-0.1-0.1-0.2-0.1-0.3 v-24.6c0-0.1,0.1-0.2,0.1-0.3l33-33c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0.1,0.3,0.2l32.1,34c0.1,0.1,0.1,0.2,0.1,0.2v45.4 C334.3,384.4,334.2,384.5,333.9,384.5z M290.5,383.8h43v-44.9l-31.7-33.7l-32.5,32.6V362L290.5,383.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_163_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_164_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1279_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1280_",
    fill: "#6A7269",
    d: "M338.5,338.9c-0.1,0-0.2-0.1-0.3-0.2l-36.3-38.4l-37.5,37.6h3.4 c0.2,0,0.4,0.2,0.4,0.4s-0.2,0.4-0.4,0.4h-4.3c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.2,0-0.3,0.1-0.4l38.4-38.5 c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0.1,0.3,0.2l36.6,38.7c0.2,0.2,0.2,0.4,0,0.5C338.7,338.9,338.6,338.9,338.5,338.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_106_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_151_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_152_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_153_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1275_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1276_",
    x: 289.2,
    y: 338.6,
    fill: "#FFFFFF",
    width: 25.2,
    height: 23.7
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_148_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_149_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_150_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1270_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1271_",
    x: 289.2,
    y: 338.6,
    fill: "#E0E0E0",
    width: 23.7,
    height: 22.2
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_141_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_142_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_145_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1263_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1264_",
    fill: "#6A7269",
    d: "M315.2,362.6c0,0.2-0.2,0.5-0.5,0.5h-25.9c-0.2,0-0.5-0.2-0.5-0.5v-24.4 c0-0.2,0.2-0.5,0.5-0.5h25.9c0.2,0,0.5,0.2,0.5,0.5V362.6z M289.2,362.3h25.2v-23.7h-25.2V362.3z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_138_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_139_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_140_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1258_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1259_",
    fill: "#6A7269",
    d: "M297.2,362.7c-0.2,0-0.4-0.2-0.4-0.5v-21c0-0.2,0.2-0.5,0.4-0.5 s0.4,0.2,0.4,0.5v21C297.6,362.6,297.4,362.7,297.2,362.7z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_118_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_128_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_137_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1253_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1254_",
    fill: "#6A7269",
    d: "M305.6,362.7c-0.2,0-0.4-0.2-0.4-0.5v-21c0-0.2,0.2-0.5,0.4-0.5 s0.4,0.2,0.4,0.5v21C306,362.6,305.8,362.7,305.6,362.7z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_115_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_116_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_117_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1248_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1249_",
    fill: "#6A7269",
    d: "M310.5,347.8h-18.4c-0.2,0-0.5-0.2-0.5-0.4c0-0.2,0.2-0.4,0.5-0.4h18.4 c0.2,0,0.5,0.2,0.5,0.4C311,347.7,310.7,347.8,310.5,347.8z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_110_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_111_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_112_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1243_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1244_",
    fill: "#6A7269",
    d: "M310.5,357h-18.4c-0.2,0-0.5-0.2-0.5-0.4c0-0.2,0.2-0.4,0.5-0.4h18.4 c0.2,0,0.5,0.2,0.5,0.4C311,356.8,310.7,357,310.5,357z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_107_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_108_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_109_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1238_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1239_",
    fill: "#6A7269",
    d: "M316.6,363.1h-31.4c-0.2,0-0.5-0.2-0.5-0.4s0.2-0.4,0.5-0.4h31.4 c0.2,0,0.5,0.2,0.5,0.4S316.9,363.1,316.6,363.1z"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_363_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_364_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1231_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1232_",
    fill: "#6A7269",
    d: "M320.2,291.7h-15.5c-0.2,0-0.4-0.2-0.4-0.4V287c0-0.2,0.2-0.4,0.4-0.4h2.2 c0.2,0,0.4,0.2,0.4,0.4c0,0.2-0.2,0.4-0.4,0.4h-1.8v3.5h14.8v-3.5h-6.5c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4h6.9 c0.2,0,0.4,0.2,0.4,0.4v4.3C320.6,291.4,320.5,291.7,320.2,291.7z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_361_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_362_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1227_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1228_",
    fill: "#6A7269",
    d: "M311.6,287.3h-3.1c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4h3.1 c0.2,0,0.4,0.2,0.4,0.4C312,287.1,311.7,287.3,311.6,287.3z"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_512_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1221_",
    fill: "#6A7269",
    d: "M195.8,338.6h-9.6c-0.2,0-0.4-0.2-0.4-0.4c0,0-0.1-3.1-2.2-5.5c-2.1-2.3-5-1.6-5.1-1.6 c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.2-0.2-0.2-0.3c0-0.2-0.4-3-3.1-3c-2.7,0-3.3,3.1-3.3,3.3c0,0.2-0.2,0.3-0.3,0.3 s-0.3-0.1-0.4-0.2c0-0.1-0.9-1.5-2.7-0.8c-1.8,0.8-2.1,4-2.1,4.1c0,0.2-0.2,0.4-0.4,0.4h-4.6c-0.2,0-0.4-0.2-0.4-0.4 c0-0.2,0.2-0.4,0.4-0.4h4.3c0.1-1,0.6-3.6,2.4-4.4c1.4-0.5,2.4-0.1,3.1,0.5c0.5-1.4,1.7-3.2,3.9-3.2c2.4,0,3.4,2,3.7,3.3 c1-0.2,3.5-0.2,5.4,1.9s2.3,4.7,2.4,5.7h9.2c0.2,0,0.4,0.2,0.4,0.4S196.1,338.6,195.8,338.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_188_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_511_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1218_",
    fill: "#6A7269",
    d: "M260.1,296.5h-4.6c-0.2,0-0.4-0.2-0.4-0.4c0,0-0.2-3.3-2.1-4.1 c-1.8-0.7-2.6,0.8-2.7,0.8c-0.1,0.2-0.2,0.2-0.4,0.2c-0.2,0-0.3-0.2-0.3-0.3c0-0.2-0.6-3.3-3.3-3.3c-2.2,0-2.9,4.2-3.1,5.9 c0,0.2-0.2,0.3-0.3,0.4c-0.2,0-0.4-0.1-0.4-0.2c0,0-0.3-0.7-0.8-0.8c-0.5-0.1-1.1,0.2-1.8,0.9c-0.1,0.1-0.2,0.1-0.3,0.1h-6.4 c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h6.3c0.8-0.8,1.6-1.1,2.3-1c0.3,0.1,0.5,0.2,0.8,0.4c0.2-1.8,1.1-5.6,3.7-5.6 c2.2,0,3.4,1.8,3.9,3.2c0.6-0.6,1.7-1.1,3.1-0.5c1.9,0.8,2.4,3.4,2.4,4.4h4.3c0.2,0,0.4,0.2,0.4,0.4S260.3,296.5,260.1,296.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_13_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_510_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1215_",
    fill: "#6A7269",
    d: "M408.5,344h-4.6c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4h4.3 c0.1-1,0.6-3.6,2.4-4.4c1.4-0.5,2.4-0.1,3.1,0.5c0.5-1.5,1.7-3.3,3.9-3.3c2.4,0,3.4,2,3.7,3.3h6.3c0.2,0,0.4,0.2,0.4,0.4 c0,0.2-0.2,0.4-0.4,0.4h-6.6c-0.2,0-0.4-0.2-0.4-0.3c0-0.2-0.4-2.9-3.1-2.9c-2.7,0-3.3,3.4-3.3,3.4c0,0.2-0.2,0.3-0.3,0.3 s-0.3-0.1-0.4-0.2c0-0.1-0.9-1.5-2.7-0.8c-1.8,0.8-2.1,4-2.1,4.1C408.9,343.8,408.7,344,408.5,344z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_261_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_262_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1211_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1212_",
    fill: "#D7F9B9",
    d: "M373.7,472.7c0,0-0.9-3-2.1-3.3c-1.1-0.3,0.2-2.8,3.2-1.7c3,1.1,2.8,0.3,4.7,0 c1.9-0.3,2.4,1.5,0.8,3.1s-2,2.4-2,2.4H375L373.7,472.7z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_250_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_251_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1207_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1208_",
    fill: "#6A7269",
    d: "M383.3,441.1h-28.6c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h28.6 c0.2,0,0.4,0.2,0.4,0.4S383.5,441.1,383.3,441.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_209_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_210_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1203_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1204_",
    fill: "#6A7269",
    d: "M365.2,471h-8.5c-0.1,0-0.2-0.2-0.2-0.4s0.1-0.4,0.2-0.4h8.5c0.1,0,0.2,0.2,0.2,0.4 S365.2,471,365.2,471z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_207_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_208_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1199_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1200_",
    fill: "#6A7269",
    d: "M385.6,454.1h-28.6c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h28.6 c0.2,0,0.4,0.2,0.4,0.4S385.8,454.1,385.6,454.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_246_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_247_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1195_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1196_",
    fill: "#6A7269",
    d: "M174.2,456.4h-15.9c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h15.9 c0.2,0,0.4,0.2,0.4,0.4S174.4,456.4,174.2,456.4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_240_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_241_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1191_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1192_",
    fill: "#6A7269",
    d: "M177.7,445h-7.6c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h7.6c0.2,0,0.4,0.2,0.4,0.4 S177.9,445,177.7,445z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_204_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_205_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1187_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1188_",
    fill: "#6A7269",
    d: "M376,473.8C376,473.8,375.9,473.8,376,473.8c-0.3-0.1-0.5-0.2-0.4-0.5l0,0 c0-0.1,0.5-2.8-2.1-4.5c-0.2-0.2-0.2-0.4-0.2-0.5c0.2-0.2,0.4-0.2,0.5-0.2c3.1,2,2.5,5.2,2.4,5.3 C376.3,473.6,376.2,473.8,376,473.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_189_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_190_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1183_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1184_",
    fill: "#6A7269",
    d: "M377.6,473.8L377.6,473.8c-0.2,0-0.4-0.2-0.4-0.4c0-0.1,0-2.8,0.9-4.1 c0.2-0.2,0.4-0.2,0.5-0.1c0.2,0.2,0.2,0.4,0.1,0.5c-0.8,1.1-0.8,3.7-0.8,3.7C378,473.6,377.8,473.8,377.6,473.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_213_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_252_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1179_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1180_",
    fill: "#6A7269",
    d: "M279.6,465.4C279.6,465.4,279.5,465.4,279.6,465.4c-0.3-0.1-0.5-0.2-0.4-0.5l0,0 c0-0.1,0.5-2.8-2.1-4.5c-0.2-0.2-0.2-0.4-0.2-0.5c0.2-0.2,0.4-0.2,0.5-0.2c3.1,2,2.5,5.2,2.4,5.3 C279.9,465.2,279.8,465.4,279.6,465.4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_211_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_212_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1175_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1176_",
    fill: "#6A7269",
    d: "M281.2,465.4L281.2,465.4c-0.2,0-0.4-0.2-0.4-0.4c0-0.1,0-2.8,0.9-4.1 c0.2-0.2,0.4-0.2,0.5-0.1c0.2,0.2,0.2,0.4,0.1,0.5c-0.8,1.1-0.8,3.7-0.8,3.7C281.6,465.2,281.4,465.4,281.2,465.4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_93_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_94_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1171_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1172_",
    fill: "#6A7269",
    d: "M144.8,423.3c-0.2,0-0.4-0.2-0.4-0.4c0-0.8-0.2-3.1-1.4-3.5c-0.2-0.1-0.3-0.3-0.2-0.5 s0.3-0.3,0.5-0.2c1.8,0.8,1.8,4.1,1.8,4.3C145.2,423.2,145,423.3,144.8,423.3L144.8,423.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_91_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_92_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1167_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1168_",
    fill: "#6A7269",
    d: "M146.3,423.3c-0.2,0-0.4-0.2-0.4-0.4c0-0.1,0-1.2,0.6-2.6c0.1-0.2,0.3-0.3,0.5-0.2 c0.2,0.1,0.3,0.3,0.2,0.5c-0.5,1.2-0.5,2.3-0.5,2.3C146.7,423.2,146.5,423.3,146.3,423.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_89_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_90_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1163_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1164_",
    fill: "#6A7269",
    d: "M143.2,423.3c-0.2,0-0.4-0.2-0.4-0.3c-0.2-0.8-0.6-1.8-1.1-1.8 c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4c1.3,0,1.8,2.2,1.8,2.4C143.7,423.1,143.5,423.3,143.2,423.3 C143.3,423.3,143.2,423.3,143.2,423.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_17_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_16_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_40_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1159_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1160_",
    fill: "#FFFFFF",
    d: "M432,435.7l-20.8,44.4l56.2-5.6l-13.5-38.8C449.4,435.7,436.7,435.7,432,435.7z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_38_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_39_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1155_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1156_",
    fill: "#E1E7EA",
    d: "M434,435.7l-15.1,35.6c-1.1,2.4,0.6,5,3.3,5l40.5-0.5c2.4,0,4.2-2.4,3.4-4.8 L454,435.7C449.4,435.7,438.7,435.7,434,435.7z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_36_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_37_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1151_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1152_",
    fill: "#6A7269",
    d: "M410.4,481.5c-0.1,0-0.2-0.1-0.2-0.2c-0.2-0.2-0.2-0.5-0.1-0.8l22-46.4 c0.2-0.2,0.3-0.3,0.5-0.1c0.2,0.2,0.2,0.5,0.1,0.8l-22,46.4C410.7,481.4,410.5,481.5,410.4,481.5z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_34_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_35_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1147_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1148_",
    fill: "none",
    stroke: "#6A7269",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M445,433.5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_32_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_33_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1143_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1144_",
    fill: "#6A7269",
    d: "M467.5,474.3L467.5,474.3c-0.2,0.1-0.5-0.1-0.6-0.4l-13.7-38.3 c-0.1-0.3,0-0.5,0.2-0.6c0.2-0.1,0.4,0.2,0.5,0.4l13.7,38.3C467.6,474,467.6,474.3,467.5,474.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_30_",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_31_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1139_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1140_",
    fill: "#6A7269",
    d: "M428.7,479.6c-0.1,0-0.2,0-0.2-0.1c-0.2-0.2-0.2-0.5-0.1-0.8l9.9-43.8 c0.1-0.2,0.3-0.4,0.5-0.2c0.2,0.2,0.2,0.5,0.1,0.8l-9.9,43.7C428.9,479.5,428.9,479.6,428.7,479.6z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_28_",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_29_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1135_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1136_",
    fill: "#6A7269",
    d: "M453.3,474.9c-0.1,0-0.1,0-0.2,0c-0.2,0-0.4-0.2-0.5-0.5l-5.7-39 c-0.1-0.3,0.1-0.5,0.3-0.5c0.2,0,0.4,0.2,0.5,0.5l5.7,39C453.5,474.7,453.4,474.9,453.3,474.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_26_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_27_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1131_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1132_",
    fill: "#6A7269",
    d: "M452.5,435h-16.8c-0.2,0-0.4-0.1-0.4-0.4c0-0.3,0.2-0.4,0.4-0.4h16.8 c0.2,0,0.4,0.1,0.4,0.4C452.9,434.9,452.7,435,452.5,435z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_24_",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_25_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1127_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1128_",
    fill: "#6A7269",
    d: "M455.9,445h-26.1c-0.2,0-0.5-0.1-0.5-0.4s0.2-0.4,0.5-0.4h26.1 c0.2,0,0.5,0.1,0.5,0.4S456.2,445,455.9,445z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_22_",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_23_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1123_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1124_",
    fill: "#6A7269",
    d: "M458.7,452.6h-31.8c-0.3,0-0.5-0.1-0.5-0.4c0-0.3,0.2-0.4,0.5-0.4h31.8 c0.3,0,0.5,0.1,0.5,0.4C459.2,452.5,459,452.6,458.7,452.6z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_20_",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_21_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1119_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1120_",
    fill: "#6A7269",
    d: "M462.7,462.6h-39.8c-0.3,0-0.5-0.1-0.5-0.4s0.2-0.4,0.5-0.4h39.8 c0.3,0,0.5,0.1,0.5,0.4S463,462.6,462.7,462.6z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_67_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_486_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_487_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1114_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1115_",
    fill: "#E6E7E8",
    points: "411.7,388.4 408.4,388.4 443.5,353.3 478.4,388.4 470.6,388.4  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_484_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_485_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1110_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1111_",
    fill: "#EDE6C8",
    points: "472.8,387 442.4,356.8 411.6,387 411.6,433.5 472.8,433.5  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_482_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_483_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1106_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1107_",
    fill: "#EDE6C8",
    d: "M472.8,427.1l31.4-0.1c6.7,0,12.2-5.5,12.2-12.2v-15.3c0-6.8-5.5-12.3-12.3-12.2 l-31.7,0.2L472.8,427.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_480_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_481_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1102_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1103_",
    fill: "#D8CFA7",
    d: "M472.8,427l4.6,0.2v-36.5h37.5c0.8,0,1.5-0.7,1.5-1.5l0,0c0-0.8-0.7-1.5-1.5-1.5 h-42.5L472.8,427z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_463_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_471_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1098_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1099_",
    fill: "#E0D9BD",
    points: "444.2,358.5 442.4,356.8 440.6,358.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_488_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1095_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1096_",
    x: 411.6,
    y: 418.2,
    fill: "#E0D9BD",
    width: 61.2,
    height: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_489_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1092_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1093_",
    x: 411.6,
    y: 402.9,
    fill: "#E0D9BD",
    width: 61.2,
    height: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_490_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1089_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1090_",
    x: 411.6,
    y: 425.8,
    fill: "#E0D9BD",
    width: 61.2,
    height: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_491_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1086_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1087_",
    x: 411.6,
    y: 410.5,
    fill: "#E0D9BD",
    width: 61.2,
    height: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_492_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1083_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1084_",
    fill: "#E0D9BD",
    points: "426.6,372.3 425,373.8 459.5,373.8 458,372.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_493_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1080_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1081_",
    x: 411.6,
    y: 395.2,
    fill: "#E0D9BD",
    width: 61.2,
    height: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_494_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1077_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1078_",
    fill: "#E0D9BD",
    points: "434.4,364.6 432.8,366.2 451.8,366.2 450.3,364.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_495_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1074_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1075_",
    fill: "#E0D9BD",
    points: "418.8,379.9 417.2,381.5 467.2,381.5 465.7,379.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_496_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1071_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1072_",
    x: 411.6,
    y: 387.6,
    fill: "#E0D9BD",
    width: 61.2,
    height: 1.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_497_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_498_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1067_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1068_",
    fill: "#D8CFA7",
    d: "M472.6,408.2v1.5h37.6c0.5,0,0.8-0.3,0.8-0.8l0,0c0-0.5-0.3-0.8-0.8-0.8H472.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_499_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1064_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1065_",
    fill: "#D8CFA7",
    d: "M472.8,423.5v1.5h37.5c0.5,0,0.8-0.3,0.8-0.8l0,0c0-0.5-0.3-0.8-0.8-0.8H472.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_500_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1061_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1062_",
    fill: "#D8CFA7",
    d: "M472.7,415.9v1.5h34.5c0.5,0,0.8-0.3,0.8-0.8l0,0c0-0.5-0.3-0.8-0.8-0.8H472.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_501_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1058_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1059_",
    fill: "#D8CFA7",
    d: "M472.5,400.6v1.5H508c0.5,0,0.8-0.3,0.8-0.8l0,0c0-0.5-0.3-0.8-0.8-0.8H472.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_502_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1055_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1056_",
    fill: "#D8CFA7",
    d: "M472.5,392.9v1.5h27.8c0.5,0,0.8-0.3,0.8-0.8l0,0c0-0.5-0.3-0.8-0.8-0.8H472.5z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_441_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_442_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1051_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1052_",
    fill: "#D8CFA7",
    points: "411.6,387 411.6,391.1 442.6,361.3 472.8,391.6 472.8,387 442.4,356.8  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_439_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_440_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1047_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1048_",
    fill: "#D6BBA5",
    d: "M453.2,359.3h45.1c4.2,0,8.1,2.2,10.3,5.9l4.6,7.9c3.7,6.4-0.9,14.5-8.3,14.5 h-23.3L453.2,359.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_427_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_428_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1043_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1044_",
    fill: "#6A7269",
    d: "M518.7,387.6h-46.3c-0.1,0-0.2-0.1-0.3-0.1l-30.6-30.7c-0.2-0.2-0.2-0.4,0-0.5 c0.2-0.2,0.4-0.2,0.5,0l30.4,30.6h46.2c0.2,0,0.4,0.2,0.4,0.4C519.1,387.5,518.9,387.6,518.7,387.6z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_425_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_426_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1039_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1040_",
    fill: "#6A7269",
    d: "M508,362.3h-55.8c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4H508 c0.2,0,0.4,0.2,0.4,0.4C508.3,362.2,508.2,362.3,508,362.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_423_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_424_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1035_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1036_",
    fill: "#6A7269",
    d: "M514.1,371.5h-52c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4h52 c0.2,0,0.4,0.2,0.4,0.4C514.5,371.4,514.3,371.5,514.1,371.5z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_421_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_422_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1031_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1032_",
    fill: "#6A7269",
    d: "M515.6,381.5h-44.4c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h44.4 c0.2,0,0.4,0.2,0.4,0.4S515.8,381.5,515.6,381.5z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_359_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_360_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1027_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1028_",
    fill: "#6A7269",
    d: "M410.8,387.6h-3.3c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.2,0-0.3,0.1-0.4l10.3-10.3 c0.2-0.2,0.4-0.2,0.5,0s0.2,0.4,0,0.5l-9.6,9.6h2.4c0.2,0,0.4,0.2,0.4,0.4S411,387.6,410.8,387.6z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_357_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_358_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1023_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1024_",
    fill: "#6A7269",
    d: "M419.6,375.8c-0.1,0-0.2,0-0.3-0.1c-0.2-0.2-0.2-0.4,0-0.5l14.1-14.1 c0.2-0.2,0.4-0.2,0.5,0c0.2,0.2,0.2,0.4,0,0.5l-14.1,14.1C419.8,375.7,419.7,375.8,419.6,375.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_355_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_356_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1019_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1020_",
    fill: "#6A7269",
    d: "M435.7,359.6c-0.1,0-0.2,0-0.3-0.1c-0.2-0.2-0.2-0.4,0-0.5l3.6-3.6 c0.2-0.2,0.4-0.2,0.5,0c0.2,0.2,0.2,0.4,0,0.5l-3.6,3.6C436,359.6,435.9,359.6,435.7,359.6z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_353_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_354_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1015_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1016_",
    fill: "#6A7269",
    d: "M477.6,387.7c-0.1,0-0.2,0-0.3-0.1l-34.7-34.7l-0.8,0.8c-0.2,0.2-0.4,0.2-0.5,0 s-0.2-0.4,0-0.5l1.1-1.1c0.2-0.2,0.4-0.2,0.5,0l35,35c0.2,0.2,0.2,0.4,0,0.5C477.7,387.7,477.7,387.7,477.6,387.7z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_7_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_478_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_479_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1011_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1012_",
    fill: "#FFFFFF",
    points: "455.9,394 455.9,421.2 458.2,421.2 458.2,423.5 426.1,423.5 426.1,421.2  429.2,421.2 429.2,394 429.2,391.4 427.6,391.4 427.6,388.4 457.9,388.4 458,391.4 455.9,391.4  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_476_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_477_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1007_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1008_",
    x: 433.8,
    y: 393.7,
    fill: "#D6BBA5",
    width: 19.9,
    height: 29.8
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_474_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_475_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1003_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1004_",
    x: 440,
    y: 399.1,
    fill: "#BFA088",
    width: 6.2,
    height: 8.6
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_472_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_473_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_999_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1000_",
    x: 440,
    y: 412.7,
    fill: "#BFA088",
    width: 6.2,
    height: 8.3
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_453_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_454_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_995_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_996_",
    fill: "#FFFFFF",
    cx: 436,
    cy: 410,
    r: 1.3
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_389_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_390_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_989_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_990_",
    fill: "#6A7269",
    d: "M453.3,423.5h-20.7c-0.2,0-0.4-0.2-0.4-0.4v-31.4c0-0.2,0.2-0.4,0.4-0.4h20.7 c0.2,0,0.4,0.2,0.4,0.4v31.4C453.6,423.4,453.5,423.5,453.3,423.5z M433,422.8h19.9v-30.6H433V422.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_385_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_386_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_983_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_984_",
    fill: "#6A7269",
    d: "M436,411.7c-0.9,0-1.7-0.8-1.7-1.7s0.8-1.7,1.7-1.7s1.7,0.8,1.7,1.7 C437.7,411,436.9,411.7,436,411.7z M436,409.2c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9s0.9-0.4,0.9-0.9 C436.9,409.5,436.4,409.2,436,409.2z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_381_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_382_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_977_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_978_",
    fill: "#6A7269",
    d: "M446.3,408.1h-6.2c-0.2,0-0.4-0.2-0.4-0.4v-8.6c0-0.2,0.2-0.4,0.4-0.4h6.2 c0.2,0,0.4,0.2,0.4,0.4v8.6C446.7,407.9,446.5,408.1,446.3,408.1z M440.4,407.3h5.4v-7.9h-5.4V407.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_377_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_378_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_971_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_972_",
    fill: "#6A7269",
    d: "M446.3,421.4h-6.2c-0.2,0-0.4-0.2-0.4-0.4v-8.3c0-0.2,0.2-0.4,0.4-0.4h6.2 c0.2,0,0.4,0.2,0.4,0.4v8.3C446.7,421.2,446.5,421.4,446.3,421.4z M440.4,420.6h5.4v-7.6h-5.4V420.6z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_373_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_374_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_965_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_966_",
    fill: "#6A7269",
    d: "M457.9,392.2h-30c-0.2,0-0.4-0.2-0.4-0.4V388c0-0.2,0.2-0.4,0.4-0.4h30 c0.2,0,0.4,0.2,0.4,0.4v3.7C458.2,392,458.1,392.2,457.9,392.2z M428.2,391.4h29.2v-3h-29.2V391.4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_327_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_352_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_961_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_962_",
    fill: "#6A7269",
    d: "M427.3,423.2c-0.2,0-0.4-0.2-0.4-0.4v-1.9c0-0.2,0.2-0.4,0.4-0.4h1.9v-26.8 c0-0.2,0.2-0.4,0.4-0.4s0.4,0.2,0.4,0.4v27.2c0,0.2-0.2,0.4-0.4,0.4h-1.9v1.5C427.6,423,427.5,423.2,427.3,423.2z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_325_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_326_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_957_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_958_",
    fill: "#6A7269",
    d: "M458.6,423.2c-0.2,0-0.4-0.2-0.4-0.4v-1.5h-1.9c-0.2,0-0.4-0.2-0.4-0.4v-27.2 c0-0.2,0.2-0.4,0.4-0.4s0.4,0.2,0.4,0.4v26.8h1.9c0.2,0,0.4,0.2,0.4,0.4v1.9C459,423,458.8,423.2,458.6,423.2z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_320_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_322_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_950_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_951_",
    fill: "#6A7269",
    d: "M472.4,433.5h-61.2c-0.2,0-0.4-0.2-0.4-0.4V387c0-0.1,0.1-0.2,0.1-0.3l30.8-30.3 c0.2-0.2,0.4-0.2,0.5,0l30.4,30.3c0.1,0.1,0.1,0.2,0.1,0.3v46.1C472.8,433.3,472.6,433.5,472.4,433.5z M411.6,432.7H472 v-45.5l-30-29.9l-30.4,29.9V432.7z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_309_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_311_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_946_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_947_",
    fill: "none",
    stroke: "#6A7269",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M472.3,387.4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_249_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_9_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_942_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_943_",
    fill: "none",
    stroke: "#6A7269",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M424.6,427"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_66_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_939_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_940_",
    fill: "#FFFFFF",
    points: "459.8,431.2 459.8,427 458.5,425.1 426.3,425.1 423.8,427 423.8,431.2  420,435.2 420,441.1 463.6,441.1 463.6,435.2  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_103_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_104_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_936_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_937_",
    x: 420,
    y: 435.8,
    fill: "#D3DADD",
    width: 43.6,
    height: 5.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_105_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_933_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_934_",
    x: 423.8,
    y: 427.4,
    fill: "#D3DADD",
    width: 36,
    height: 3.8
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_10_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_507_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_928_",
    fill: "#6A7269",
    d: "M464,441.1h-43.6c-0.2,0-0.4-0.2-0.4-0.4v-5.5c0-0.1,0-0.2,0.1-0.2l3.7-3.9v-4.1 c0-0.1,0-0.2,0.1-0.2l2.1-2.3c0.1-0.1,0.2-0.2,0.3-0.2h32.2c0.2,0,0.2,0.1,0.3,0.2l1.7,2.3c0.1,0.1,0.1,0.2,0.1,0.2v4.1 l3.7,3.9c0.1,0.1,0.1,0.2,0.1,0.2v5.5C464.4,441,464.2,441.1,464,441.1z M420.8,440.4h42.8v-5l-3.7-3.9 c-0.1-0.1-0.1-0.2-0.1-0.2v-4.1l-1.5-2.1h-31.8l-1.8,2.1v4.1c0,0.1,0,0.2-0.1,0.2l-3.7,3.9L420.8,440.4L420.8,440.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_11_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_506_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_925_",
    fill: "#6A7269",
    d: "M459.8,427.4h-32.9c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h32.9 c0.2,0,0.4,0.2,0.4,0.4S460,427.4,459.8,427.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_12_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_461_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_922_",
    fill: "#6A7269",
    d: "M459.8,431.2h-35.2c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h35.2 c0.2,0,0.4,0.2,0.4,0.4S460,431.2,459.8,431.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_15_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_460_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_919_",
    fill: "#6A7269",
    d: "M463.6,435.8H423c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h40.5 c0.2,0,0.4,0.2,0.4,0.4S463.8,435.8,463.6,435.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_245_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_248_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_914_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_915_",
    x: 420,
    y: 398.8,
    fill: "#FFFFFF",
    width: 4.4,
    height: 4
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_237_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_238_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_908_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_909_",
    fill: "#6A7269",
    d: "M423.6,402.3h-4.4c-0.2,0-0.4-0.2-0.4-0.4v-4c0-0.2,0.2-0.4,0.4-0.4h4.4 c0.2,0,0.4,0.2,0.4,0.4v4C424,402.1,423.8,402.3,423.6,402.3z M419.5,401.6h3.7v-3.2h-3.7V401.6z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_80_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_83_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_904_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_905_",
    fill: "#6A7269",
    d: "M411.6,432.7v-45.5l30.5-30.2c0.2-0.2,0.2-0.4,0-0.5c-0.2-0.2-0.4-0.2-0.5,0 l-30.7,30.4c-0.1,0.1-0.1,0.2-0.1,0.3v46.1c0,0.2,0.2,0.4,0.4,0.4h61.2c0.2,0,0.4-0.2,0.4-0.4l-0.8-5.8v5.4L411.6,432.7 L411.6,432.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_42_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_901_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_902_",
    fill: "#6A7269",
    d: "M514.1,427.4v-0.8l-41.7-0.1c-0.2,0-0.2,0.1-0.3,0.1c-0.1,0.1-0.1,0.2-0.1,0.3v0.4 l41.7,0.1H514.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_43_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_81_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_898_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_899_",
    fill: "#6A7269",
    d: "M502.6,357h-55.8c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4h55.8 c0.2,0,0.4,0.2,0.4,0.4C503,356.8,502.8,357,502.6,357z"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_244_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_296_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_299_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_890_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_891_",
    fill: "#FFFFFF",
    points: "376.4,408.6 372.6,413.4 372.6,432.7 376.7,432.7 380.2,432.7 380.2,413.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_298_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_887_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_888_",
    fill: "#E2D7C7",
    points: "377.7,409.7 374.1,414 374.1,432 377.8,432 380.2,432 380.2,413.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_297_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_445_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_883_",
    fill: "#6A7269",
    d: "M380.6,432.7h-7.6c-0.2,0-0.4-0.2-0.4-0.4v-18.9c0-0.1,0-0.2,0.1-0.2l3.8-4.8 c0.2-0.2,0.5-0.2,0.6,0l3.8,4.8c0.1,0.1,0.1,0.2,0.1,0.2v18.9C381,432.6,380.8,432.7,380.6,432.7z M373.3,432h6.9v-18.4 l-3.4-4.4l-3.4,4.4V432z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_292_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_295_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_878_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_879_",
    fill: "#FFFFFF",
    points: "384,408.6 380.2,413.4 380.2,432.7 383.9,432.7 387.9,432.7 387.9,413.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_294_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_875_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_876_",
    fill: "#E2D7C7",
    points: "384.9,409.7 381,414 381,432 384.9,432 387.9,432 387.9,413.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_293_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_437_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_871_",
    fill: "#6A7269",
    d: "M388.2,432.7h-7.6c-0.2,0-0.4-0.2-0.4-0.4v-18.9c0-0.1,0-0.2,0.1-0.2l3.8-4.8 c0.2-0.2,0.5-0.2,0.6,0l3.8,4.8c0.1,0.1,0.1,0.2,0.1,0.2v18.9C388.6,432.6,388.5,432.7,388.2,432.7z M381,432h6.9v-18.4 l-3.4-4.4l-3.4,4.4V432z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_284_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_287_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_866_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_867_",
    fill: "#FFFFFF",
    points: "399.3,408.6 395.5,413.4 395.5,432.7 399.2,432.7 403.2,432.7 403.2,413.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_286_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_863_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_864_",
    fill: "#E2D7C7",
    points: "400.2,409.7 396.3,414 396.3,432 400.2,432 403.2,432 403.2,413.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_285_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_431_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_859_",
    fill: "#6A7269",
    d: "M403.5,432.7h-7.7c-0.2,0-0.4-0.2-0.4-0.4v-18.9c0-0.1,0-0.2,0.1-0.2l3.8-4.8 c0.2-0.2,0.5-0.2,0.6,0l3.8,4.8c0.1,0.1,0.1,0.2,0.1,0.2v18.9C403.9,432.6,403.8,432.7,403.5,432.7z M396.3,432h6.9v-18.4 l-3.4-4.4l-3.4,4.4V432z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_280_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_283_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_854_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_855_",
    fill: "#FFFFFF",
    points: "407,408.6 403.2,413.4 403.2,432.7 406.6,432.7 410.8,432.7 410.8,413.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_282_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_851_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_852_",
    fill: "#E2D7C7",
    points: "407.9,409.7 403.9,414 403.9,432 407.6,432 410.8,432 410.8,413.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_281_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_328_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_847_",
    fill: "#6A7269",
    d: "M411.2,432.7h-7.6c-0.2,0-0.4-0.2-0.4-0.4v-18.9c0-0.1,0-0.2,0.1-0.2l3.8-4.8 c0.2-0.2,0.5-0.2,0.6,0l3.8,4.8c0.1,0.1,0.1,0.2,0.1,0.2v18.9C411.6,432.6,411.4,432.7,411.2,432.7z M403.9,432h6.9v-18.4 l-3.4-4.4l-3.4,4.4V432z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_73_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_76_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_841_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_842_",
    fill: "#FFFFFF",
    points: "194.3,408.6 190.5,413.4 190.5,432.7 194.6,432.7 198.1,432.7 198.1,413.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_75_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_838_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_839_",
    fill: "#E2D7C7",
    points: "195.6,409.7 192,414 192,432 195.7,432 198.1,432 198.1,413.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_74_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_315_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_834_",
    fill: "#6A7269",
    d: "M198.5,432.7h-7.7c-0.2,0-0.4-0.2-0.4-0.4v-18.9c0-0.1,0-0.2,0.1-0.2l3.8-4.8 c0.2-0.2,0.5-0.2,0.6,0l3.8,4.8c0.1,0.1,0.1,0.2,0.1,0.2v18.9C198.9,432.6,198.7,432.7,198.5,432.7z M191.2,432h6.9v-18.4 l-3.4-4.4l-3.4,4.4V432z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_69_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_72_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_829_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_830_",
    fill: "#FFFFFF",
    points: "202,408.6 198.1,413.4 198.1,432.7 201.8,432.7 205.8,432.7 205.8,413.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_71_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_826_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_827_",
    fill: "#E2D7C7",
    points: "202.9,409.7 198.9,414 198.9,432 202.9,432 205.8,432 205.8,413.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_70_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_307_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_822_",
    fill: "#6A7269",
    d: "M206.2,432.7h-7.6c-0.2,0-0.4-0.2-0.4-0.4v-18.9c0-0.1,0-0.2,0.1-0.2l3.8-4.8 c0.2-0.2,0.5-0.2,0.6,0l3.8,4.8c0.1,0.1,0.1,0.2,0.1,0.2v18.9C206.6,432.6,206.4,432.7,206.2,432.7z M198.9,432h6.9v-18.4 l-3.4-4.4l-3.4,4.4V432z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_63_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_68_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_817_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_818_",
    fill: "#FFFFFF",
    points: "217.3,408.6 213.4,413.4 213.4,432.7 217.2,432.7 221.1,432.7 221.1,413.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_65_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_814_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_815_",
    fill: "#E2D7C7",
    points: "218.2,409.7 214.2,414 214.2,432 218.2,432 221.1,432 221.1,413.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_64_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_302_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_810_",
    fill: "#6A7269",
    d: "M221.5,432.7h-7.7c-0.2,0-0.4-0.2-0.4-0.4v-18.9c0-0.1,0-0.2,0.1-0.2l3.8-4.8 c0.2-0.2,0.5-0.2,0.6,0l3.8,4.8c0.1,0.1,0.1,0.2,0.1,0.2v18.9C221.8,432.6,221.7,432.7,221.5,432.7z M214.2,432h6.9v-18.4 l-3.4-4.4l-3.4,4.4V432z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_8_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_62_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_805_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_806_",
    fill: "#FFFFFF",
    points: "224.9,408.6 221.1,413.4 221.1,432.7 224.5,432.7 228.7,432.7 228.7,413.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_61_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_802_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_803_",
    fill: "#E2D7C7",
    points: "225.8,409.7 221.8,414 221.8,432 225.6,432 228.7,432 228.7,413.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_60_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_243_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_798_",
    fill: "#6A7269",
    d: "M229.1,432.7h-7.6c-0.2,0-0.4-0.2-0.4-0.4v-18.9c0-0.1,0-0.2,0.1-0.2l3.8-4.8 c0.2-0.2,0.5-0.2,0.6,0l3.8,4.8c0.1,0.1,0.1,0.2,0.1,0.2v18.9C229.5,432.6,229.3,432.7,229.1,432.7z M221.8,432h6.9v-18.4 l-3.4-4.4l-3.4,4.4V432z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_82_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_144_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_369_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_792_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_793_",
    fill: "#FFFFFF",
    points: "127.8,427.4 99.4,447.3 138.5,448.2 159,427.4  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_430_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_789_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_790_",
    fill: "#E1E7EA",
    d: "M131.1,427.4l-21.3,15.3c-2.2,1.6-1.1,5,1.6,5.1l27.2,0.5l20.5-20.9L131.1,427.4 L131.1,427.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_308_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_310_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_786_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_787_",
    fill: "none",
    stroke: "#6A7269",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M145.8,406.2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_219_",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_220_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_782_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_783_",
    fill: "#6A7269",
    d: "M146.9,438.8h-31.7c-0.2,0-0.4-0.1-0.2-0.4s0.3-0.4,0.5-0.4h31.7 c0.2,0,0.4,0.1,0.2,0.4C147.3,438.8,147.1,438.8,146.9,438.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_217_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_218_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_778_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_779_",
    fill: "#6A7269",
    d: "M138.3,448.5l-31.6-0.5c-0.2,0-0.4-0.1-0.2-0.4c0.1-0.3,0.3-0.4,0.5-0.4l31.6,0.5 c0.2,0,0.4,0.1,0.2,0.4C138.8,448.4,138.5,448.5,138.3,448.5z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_222_",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_19_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_775_",
    fill: "#6A7269",
    d: "M146,427.4l-20.5,17.5c-0.2,0.2-0.2,0.6-0.1,0.8c0.1,0,0.1,0.1,0.2,0.1 c0.2,0,0.3-0.2,0.5-0.5l21-17.9H146z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_316_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_771_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_772_",
    fill: "#6A7269",
    d: "M126.4,427.4l-24.2,16.5c-0.2,0.2-0.3,0.6-0.2,0.8c0.1,0.1,0.1,0.2,0.2,0.2 c0.1,0,0.2-0.2,0.4-0.3l25.2-17.1L126.4,427.4L126.4,427.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_312_",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_18_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_769_",
    fill: "#6A7269",
    d: "M136.3,427.4l-21.4,16.4c-0.2,0.2-0.2,0.6-0.2,0.8c0.1,0.1,0.1,0.2,0.2,0.2 c0.2,0,0.3-0.2,0.4-0.4l22.1-16.9H136.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_290_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_765_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_766_",
    fill: "#6A7269",
    d: "M159,427.4L141,446c-0.2,0.3-0.2,0.6,0.1,0.7l0.1,0.1c0.2,0,0.4-0.3,0.5-0.5 l18.2-18.8L159,427.4L159,427.4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_291_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_300_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_761_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_762_",
    fill: "#EDE6C8",
    d: "M121.3,432.4l69.2-0.2v-39.9l-69.2,0.3c-6.8,0-12.3,5.5-12.4,12.3l-0.2,14.8 C108.7,426.8,114.3,432.4,121.3,432.4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_216_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_757_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_758_",
    fill: "#D8CFA7",
    d: "M108.6,394.5L108.6,394.5c0,0.8,0.7,1.5,1.5,1.5h81.1v-3.1h-81.1 C109.3,392.9,108.6,393.6,108.6,394.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_234_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_235_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_754_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_755_",
    fill: "#C6EAF4",
    d: "M140.5,364.6h46.3l8.9,28.3h-67.6c-6,0-9.3-7.1-5.3-11.6l12.4-14.2 C136.6,365.5,138.5,364.6,140.5,364.6z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_304_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_750_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_751_",
    fill: "#6A7269",
    d: "M196.1,392.4l-9.7-31.4c-0.1-0.2-0.2-0.2-0.4-0.2h-49.9c-0.2,0-0.4,0.2-0.4,0.4 c0,0.2,0.2,0.4,0.4,0.4h49.6l9.4,30.6h-4.4c-0.2,0-0.4,0.2-0.4,0.4V432l-81.1-0.1v0.8l81.5,0.1c0.8,0,0.8,0,0.8,0 c0.1,0,0.2-0.1,0.3-0.2c0.1-0.1-0.7-0.2-0.7-0.3v-39.3h4.5c0.2,0,0.2-0.1,0.3-0.2C196.1,392.7,196.1,392.6,196.1,392.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_228_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_229_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_747_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_748_",
    fill: "#6A7269",
    d: "M183.6,366.9h-55.8c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h55.8 c0.2,0,0.4,0.2,0.4,0.4S183.8,366.9,183.6,366.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_226_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_227_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_726_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_727_",
    fill: "#6A7269",
    d: "M186.7,376.1h-65.8c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h65.8 c0.2,0,0.4,0.2,0.4,0.4S186.9,376.1,186.7,376.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_224_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_225_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_722_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_723_",
    fill: "#6A7269",
    d: "M189.7,385.3h-75c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h75c0.2,0,0.4,0.2,0.4,0.4 S189.9,385.3,189.7,385.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_136_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_143_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_718_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_719_",
    fill: "#6A7269",
    d: "M191.2,392.9h-82.6c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h82.6 c0.2,0,0.4,0.2,0.4,0.4S191.5,392.9,191.2,392.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_154_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_214_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_215_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_714_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_715_",
    fill: "#FFFFFF",
    points: "147.6,401.7 147.6,428.9 149.9,428.9 149.9,431.2 117.8,431.2 117.8,428.9  120.9,428.9 120.9,401.7 120.9,399.1 119.3,399.1 119.3,396 149.6,396 149.7,399.1 147.6,399.1  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_200_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_201_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_707_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_708_",
    x: 125.5,
    y: 401.4,
    fill: "#C6EAF4",
    width: 19.9,
    height: 29.8
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_198_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_199_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_702_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_703_",
    x: 131.7,
    y: 406.7,
    fill: "#C2CFD3",
    width: 6.2,
    height: 8.6
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_196_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_197_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_698_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_699_",
    x: 131.7,
    y: 420.3,
    fill: "#C2CFD3",
    width: 6.2,
    height: 8.3
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_194_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_195_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_694_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_695_",
    fill: "#FFFFFF",
    cx: 127.7,
    cy: 417.6,
    r: 1.3
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_187_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_191_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_680_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_681_",
    fill: "#6A7269",
    d: "M145,431.2h-20.7c-0.2,0-0.4-0.2-0.4-0.4v-31.4c0-0.2,0.2-0.4,0.4-0.4H145 c0.2,0,0.4,0.2,0.4,0.4v31.4C145.3,431,145.2,431.2,145,431.2z M124.7,430.4h19.9v-30.6h-19.9V430.4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_180_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_181_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_674_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_675_",
    fill: "#6A7269",
    d: "M127.7,419.3c-0.9,0-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7 C129.4,418.6,128.6,419.3,127.7,419.3z M127.7,416.8c-0.5,0-0.9,0.4-0.9,0.9s0.4,0.9,0.9,0.9c0.5,0,0.9-0.4,0.9-0.9 S128.1,416.8,127.7,416.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_170_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_177_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_668_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_669_",
    fill: "#6A7269",
    d: "M138,415.7h-6.2c-0.2,0-0.4-0.2-0.4-0.4v-8.6c0-0.2,0.2-0.4,0.4-0.4h6.2 c0.2,0,0.4,0.2,0.4,0.4v8.6C138.4,415.6,138.2,415.7,138,415.7z M132.1,415h5.4v-7.9h-5.4V415z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_165_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_166_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_599_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_600_",
    fill: "#6A7269",
    d: "M138,429h-6.2c-0.2,0-0.4-0.2-0.4-0.4v-8.3c0-0.2,0.2-0.4,0.4-0.4h6.2 c0.2,0,0.4,0.2,0.4,0.4v8.3C138.4,428.8,138.2,429,138,429z M132.1,428.3h5.4v-7.6h-5.4V428.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_159_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_160_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_593_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_594_",
    fill: "#6A7269",
    d: "M149.6,399.8h-30c-0.2,0-0.4-0.2-0.4-0.4v-3.7c0-0.2,0.2-0.4,0.4-0.4h30 c0.2,0,0.4,0.2,0.4,0.4v3.7C149.9,399.7,149.8,399.8,149.6,399.8z M120,399.1h29.2v-3H120V399.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_157_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_158_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_589_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_590_",
    fill: "#6A7269",
    d: "M119,430.8c-0.2,0-0.4-0.2-0.4-0.4v-1.9c0-0.2,0.2-0.4,0.4-0.4h1.9v-26.8 c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4v27.2c0,0.2-0.2,0.4-0.4,0.4h-1.9v1.5C119.3,430.7,119.2,430.8,119,430.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_155_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_156_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_584_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_585_",
    fill: "#6A7269",
    d: "M150.3,430.8c-0.2,0-0.4-0.2-0.4-0.4v-1.5H148c-0.2,0-0.4-0.2-0.4-0.4v-27.2 c0-0.2,0.2-0.4,0.4-0.4s0.4,0.2,0.4,0.4v26.8h1.9c0.2,0,0.4,0.2,0.4,0.4v1.9C150.7,430.7,150.6,430.8,150.3,430.8z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_133_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_134_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_579_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_580_",
    fill: "none",
    stroke: "#6A7269",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M108.2,392.8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_84_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_130_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_131_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_132_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_571_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_572_",
    x: 159.1,
    y: 401.4,
    fill: "#FFFFFF",
    width: 22.9,
    height: 21.4
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_126_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_127_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_129_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_566_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_567_",
    x: 159.1,
    y: 401.4,
    fill: "#C6EAF4",
    width: 21.4,
    height: 19.9
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_121_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_122_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_123_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_555_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_556_",
    fill: "#6A7269",
    d: "M182.8,423.2c0,0.2-0.2,0.4-0.4,0.4h-23.7c-0.2,0-0.4-0.2-0.4-0.4V401 c0-0.2,0.2-0.4,0.4-0.4h23.7c0.2,0,0.4,0.2,0.4,0.4V423.2z M159.1,422.8h22.9v-21.4h-22.9V422.8z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_114_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_119_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_120_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_546_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_547_",
    fill: "#6A7269",
    d: "M166.4,423.5c-0.2,0-0.4-0.2-0.4-0.4v-19.2c0-0.2,0.2-0.4,0.4-0.4s0.4,0.2,0.4,0.4 v19.2C166.8,423.2,166.6,423.5,166.4,423.5z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_101_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_102_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_113_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_541_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_542_",
    fill: "#6A7269",
    d: "M174,423.5c-0.2,0-0.4-0.2-0.4-0.4v-19.2c0-0.2,0.2-0.4,0.4-0.4 c0.2,0,0.4,0.2,0.4,0.4v19.2C174.4,423.2,174.3,423.5,174,423.5z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_98_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_99_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_100_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_536_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_537_",
    fill: "#6A7269",
    d: "M178.3,409.8h-16.8c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4h16.8 c0.2,0,0.4,0.2,0.4,0.4C178.7,409.6,178.6,409.8,178.3,409.8z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_95_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_96_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_97_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_528_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_529_",
    fill: "#6A7269",
    d: "M178.3,418.2h-16.8c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h16.8 c0.2,0,0.4,0.2,0.4,0.4S178.6,418.2,178.3,418.2z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_85_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_86_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_87_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_522_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_523_",
    fill: "#6A7269",
    d: "M184.7,423.5h-28.8c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h28.8 c0.2,0,0.4,0.2,0.4,0.4S185,423.5,184.7,423.5z"
  })))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLawndoctorsIllustrationsFreeinstantpriceLotsizeCity);
export default __webpack_public_path__ + "static/media/lawndoctors-illustrations-freeinstantprice-lotsize-city.10aee917.svg";
export { ForwardRef as ReactComponent };